/** Маршруты входа. Экраны входа (телефон → код → пароль) регистрирует раздел area='public' с путём `login`. */
export const AUTH_PATHS = {
  login: '/login',
  mfa: '/login/mfa',
  /** После входа: новые версии документов (ПОРТ-42), выбор клиники (ПОРТ-16), начало работы без клиники. */
  welcome: '/welcome',
} as const;

/** Куда вернуться после входа: только внутренние пути (защита от открытого перенаправления). */
export function safeNextPath(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/login')) return '/';
  return value;
}
